import { App } from 'ovee.js';
import OveeBarba from '@ovee.js/barba';
import { isIOS, isAndroid } from '@/tools/browser';
import { setup } from '@/tools/braze';
import DialogLazyLoad from './components/DialogLazyLoad';
import MediaDialog from './components/MediaDialog';
import OpenStaticDialog from './components/OpenStaticDialog';
import StaticDialog from './components/StaticDialog';
import InViewport from './components/InViewport';
import SliderMain from './components/SliderMain';
import ScrollTo from './components/ScrollTo';
import NavToggle from './components/NavToggle';
import BaseForm from './components/BaseForm';
import MainMenu from './components/MainMenu';
import CursorMode from './components/CursorMode';
import AccordionContainer from './components/AccordionContainer';
import LazyLoad from './components/LazyLoad';
import EventsJustify from './components/EventsJustify';
import AutoplayMq from './components/AutoplayMq';
import FixedBtn from './components/FixedBtn';
import SliderGallery from './components/SliderGallery';
import FlexibleEvent from './components/FlexibleEvent';
import SliderStages from './components/SliderStages';
import SliderFlexibleGallery from './components/SliderFlexibleGallery';
import EventNav from './components/EventNav';
import ViewMore from './components/ViewMore';
import SliderFlexibleModal from './components/SliderFlexibleModal';
import FlexibleModal from './components/FlexibleModal';
import HeaderBlend from './components/HeaderBlend';
import BackLink from './components/BackLink';
import HeroHeightHelper from './components/HeroHeightHelper';
import ScrollToModule from './modules/ScrollTo'; // import CustomCursorModule from './modules/CustomCursor';

import AutoStaticDialogModule from './modules/AutoStaticDialog';
import VhFix from './modules/VhFix';
import defaultTransition from './transitions/default';
import PhoneInput from './components/PhoneInput';
import DropdownList from './components/DropdownList';
var root = document.body;
var app = new App({
  config: {
    baseUrl: root.dataset.baseHref
  },
  components: [InViewport, SliderMain, ScrollTo, NavToggle, BaseForm, MainMenu, AccordionContainer, CursorMode, LazyLoad, EventsJustify, MediaDialog, DialogLazyLoad, OpenStaticDialog, StaticDialog, AutoplayMq, FixedBtn, SliderGallery, EventNav, SliderStages, SliderFlexibleGallery, FlexibleEvent, ViewMore, SliderFlexibleModal, FlexibleModal, HeaderBlend, PhoneInput, BackLink, HeroHeightHelper, DropdownList]
});
app.use(OveeBarba, {
  transitions: [defaultTransition],
  timeout: 20000,
  preventRunning: true,
  usePrefetch: isIOS() && !isAndroid(),
  hooks: {
    after: function after() {
      if (global.dataLayer !== undefined) {
        try {
          global.dataLayer.push({
            event: 'content-view',
            'content-name': global.location.pathname
          }); // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    },
    beforeEnter: function beforeEnter() {
      if (document.location.hash.length > 1) {
        app.getModule('ScrollTo').scrollTo(document.location.hash, true);
      }
    }
  }
});
app.use(ScrollToModule); // app.use(CustomCursorModule);

app.use(AutoStaticDialogModule);
app.use(VhFix);
app.run(root);
setup();